export default {
  variantIds: []
};
